import { Autocomplete, Box, Button, Checkbox, Drawer, FormControlLabel, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom, CommonTimeRangePicker } from "../../../../Components/Common Components/CommonComponents";
import '../reports.css';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { formatDate, AmountFormat, timeOnlyConvert, GetInvestigationName } from '../../../../Components/CommonFunctions/CommonFunctions';
import { DateTime } from 'luxon';
import { CurrencySymbol } from '../../../../Utility/Constants';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

class CopPatientReport extends Component {

    constructor() {
        super()
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            companyName: [],
            employeeName: "",
            dateIndex: 1,
            corporatePatientData: [],
            corporateFilter: [],
            corporatePatientPayable: null,
            patientPayable: null,
            corporateTotalAmount: null,
            corporateFilterList: [],
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilterDatas: {
                "startTime":null,
                "endTime":null,
                "onError":false,
            },
            timeError: false,
            return_amount: 0,
            corporateTotalNetAmount: null,
            disableBtn: false,
            InPatientSelected: true,
            OutPatientSelected: true,
            PharmacySelected: localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? false : true,
            LabSelected: true,
            RadiologySelected: localGetItem("Show_Radiology_Bills_In_FO") === "false" ? false : true,
            moduleType: ['op', 'ip', 'lab', (localGetItem("Show_Radiology_Bills_In_FO") === "false" ? "" : 'radiology'), (localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? "" : 'pharmacy')] 
        }
    }

    componentDidMount() {
        this.getCorportatePatientData()
        this.getCorportateFilterList()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, ()=> {
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas:this.state.FilterDatas
            })
        })
    }

    generateUrl = () => {
        const { fromPharmacy, fromRadiology } = this.props;
        const { FilterDatas, employeeName, fromDate, toDate, companyName } = this.state;
        const company_name = companyName.map(element => element.company_name);
        const start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
        const end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
        const setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        const setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        const baseUrl = (localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_FO_REPORTS_CORPORATE_PATIENT : Serviceurls.FO_REPORTS_CORPORATE_PATIENT;
        let url = `${baseUrl}?employee_name=${employeeName}&company_name=${company_name}&from_date=${fromDate}&to_date=${toDate}&start_time=${setStartTime}&end_time=${setEndTime}`;
        if (fromPharmacy) { url += "&mode=pharmacy" + `&clinic_id=${localGetItem('clinicId')}` }
        else if (fromRadiology) { url += `&mode=${localGetItem('is_investigation_module') === "true" ? GetInvestigationName() : "radiology"}` + `&clinic_id=${localGetItem('clinicId')}` }
        else{url += `&mode=${this.state.moduleType}`};
        return url;
    }

    getCorportatePatientData = () => {
        try {
            this.LoaderFunction(true)
            const url = this.generateUrl();
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            corporatePatientData: response.data.data,
                            corporateTotalAmount: response.data.total_amount,
                            corporatePatientPayable: response.data.corporate_payable,
                            patientPayable: response.data.patient_payable,
                            FilteredFromDate: this.state.fromDate,
                            FilteredToDate: this.state.toDate,
                            return_amount: response.data.return_amount,
                            corporateTotalNetAmount: response.data.net_total_amount,
                        },()=>{this.LoaderFunction(false)})
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }

    getCorportateFilterList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            corporateFilterList: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getCorpBillExcel = () => {
        try {
            const url = this.generateUrl();
            this.setState({ disableBtn: true })
            RestAPIService.excelGet(url + `&export_type=excel`)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 

                        let filename = response.headers["content-disposition"]?.split("filename=")[1]
                        // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({ disableBtn: false })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error?.message);
                    this.setState({ disableBtn: false })
                })
        } catch (error) {
            this.errorMessage(error.message);
            this.setState({ disableBtn: false })
        }
    }

    selectedTime = (start, end,error) => {
        this.state.FilterDatas.startTime = start
        this.state.FilterDatas.endTime = end
        this.setState({ FilterDatas: this.state.FilterDatas, timeError: error })
    }
    handleCheckBox = (e, key) => {
        let states = this.state
        states[key] = e.target.checked
        this.setState({
            states
        })
        let billType =[]
        if(this.state.OutPatientSelected){
            billType.push('op')
        }
        if(this.state.InPatientSelected){
            billType.push('ip')
        }
        if(this.state.LabSelected){
            billType.push('lab')
        }
        if(this.state.RadiologySelected){
            billType.push('radiology')
        }
        if(this.state.PharmacySelected){
            billType.push('pharmacy')
        }
        this.setState({
            moduleType: billType 
        })
    }
    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)} 
                            HideAllMenu={true}/>
                    </Box>
                    <Box sx={{width: '22vw'}}>
                    <CommonTimeRangePicker
                        startTime={this.state.FilterDatas?.startTime}
                        endTime={this.state.FilterDatas?.endTime}
                        selectedTime={this.selectedTime.bind(this)}
                        FromDate={this.state.fromDate}
                        ToDate={this.state.toDate}
                        onError={this.state.FilterDatas.onError}
                    />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            fullWidth
                            size='small'
                            label={t("EmployeeName")}
                            name="employeeName"
                            value={this.state.employeeName}
                            onChange={(e) => { this.onChangeHandler(e) }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.corporateFilterList?.map((item) => item)}
                            getOptionLabel={(option) => (option?.company_name)}
                            value={this.state.companyName}
                            onChange={(event, newValue) => {
                                this.setState({ companyName: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("selectCom")}
                                />
                            )}
                        />
                    </Box>
                    {(this.props.fromPharmacy || this.props.fromRadiology) ? null : <Box component={"div"}>
                        <Box className="eMed_Filter_Header">
                            <Typography marginLeft={"1vw"}>{"Module Type"}</Typography>
                        </Box>
                        <Box className="eMed_CheckBox_Group">
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.InPatientSelected} onChange={(e) => { this.handleCheckBox(e, "InPatientSelected",) }} size='small' />} label={t("InPatient")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.OutPatientSelected} onChange={(e) => { this.handleCheckBox(e, "OutPatientSelected") }} size='small' />} label={t("OutPatient")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Pharmacy_Bills_In_FO") === "false"} checked={this.state.PharmacySelected} onChange={(e) => { this.handleCheckBox(e, "PharmacySelected") }} size='small' />} label={t("Pharmacy")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.LabSelected} onChange={(e) => { this.handleCheckBox(e, "LabSelected") }} size='small' />} label={t("Laboratory")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox disabled={localGetItem("Show_Radiology_Bills_In_FO") === "false"} checked={this.state.RadiologySelected} onChange={(e) => { this.handleCheckBox(e, "RadiologySelected") }} size='small' />} label={t("Radiology")} />
                        </Box>
                    </Box>}
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({ companyName: [], employeeName: [],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime":null,
                                    "endTime":null,
                                    "onError": false
                                },
                                timeError: false,
                                InPatientSelected: true,
                                OutPatientSelected: true,
                                PharmacySelected: localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? false : true,
                                LabSelected: true,
                                RadiologySelected: localGetItem("Show_Radiology_Bills_In_FO") === "false" ? false : true,
                                moduleType: ['op', 'ip', 'lab', (localGetItem("Show_Radiology_Bills_In_FO") === "false" ? "" : 'radiology'), (localGetItem("Show_Pharmacy_Bills_In_FO") === "false" ? "" : 'pharmacy')] 
                             }, () => this.getCorportatePatientData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                    disabled={this.state.FilterDatas.startTime ? (this.state.FilterDatas.startTime && this.state.FilterDatas.endTime && this.state.timeError != true) ? false : true : false}
                        onClick={() => {
                            this.getCorportatePatientData()
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }
    gridToolBar = () => {
        let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : ''
        let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : ''
        let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.FilteredFromDate) },
            { label: "To Date", value: formatDate(this.state.FilteredToDate) },
        ]
        if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
            TextArray.push(
                { label: "Start Time", value: timeOnlyConvert(setStartTime) },
                { label: "End Time", value: timeOnlyConvert(setEndTime) }
            )
        }
        var ExportData = [];
        this.state.corporatePatientData?.length > 0 && this.state.corporatePatientData.map((item) => {
            const data = {
                "Employee Name": item?.employee_name,
                "Employee ID":item?.employee_id,
                "Company Name": item?.company_name,
                "Bill Number": item.invoice_number,
                "Bill Date": item.invoice_date,
                "Bill Type": item.module_type,
                "Purpose Of Visit": item.pov || "",
                "Total Value": item.gross_amount || 0,
                "Corporate Payable": item.payable_amount,
                "Patient Payable": item.patient_payable || 0
            };
            ExportData.push(data);
        });
        return (
            <Box>
                <CommonGridToolBarWithFilterTextCustom FilterTextArray={TextArray} data={ExportData} title={"Corporate Patient Bill Report"} filename={"Corporate Patient Bill Report"} />
            </Box>

        )
    }
    render() {
        this.state.corporatePatientData.forEach((element, index) => element.sno = index + 1)
        const { t } = this.props
        const columns = [
            {
                field: "employee_name", headerName: t("Employee Details"), flex: 0.143,
                renderCell: (params) => {
                    const employeeName = params?.row?.employee_name?.trim();
                    return(<Box component={'div'}>{employeeName ? employeeName?.length > 12 ?
                    <Tooltip placement='top' title={employeeName} arrow><div>{employeeName.slice(0, 12) + '...'}</div></Tooltip> : employeeName : "-"}
                    {params?.row?.employee_id ? <Typography id='eMed_Com_Patient_UhidText'>ID: {params?.row?.employee_id}</Typography> : ""}
                    </Box>)},
                    valueGetter: (params) => {
                    const Name = params.row?.employee_name  || "";
                    const ID = params.row?.employee_id  || "";
                    return `${Name} ${ID}`;
                }
            },
            {
                field: "company_name", headerName: t("CompanyName"), flex: 0.143,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.company_name ? params?.row?.company_name?.length > 15 ?
                    <Tooltip placement='top' title={params?.row?.company_name} arrow><div>{params?.row?.company_name.slice(0, 15) + '...'}</div></Tooltip> : params?.row?.company_name : "-"}</Box>)
            },
            {
                field: "invoice_number", headerName: t("BillNumber"), flex: 0.143, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.invoice_number ? params?.row?.invoice_number?.length > 9 ? <Tooltip placement='top' title={params?.row?.invoice_number} arrow>
                    <Box>{"..." + params?.row?.invoice_number.slice(9)}</Box>
                </Tooltip> : params?.row?.invoice_number : "-"}</Box>)
            },
            {
                field: "invoice_date", headerName: t("BillDate"), flex: 0.143, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.invoice_date ? params?.row?.invoice_date : "-"}</Box>)
            },
            {
                field: "module_type", headerName: t("BillType"), flex: 0.143,
                renderCell: (params) => (<Box component={'div'}>
                    <Typography>{params?.row?.module_type ? params?.row?.module_type : "-"}</Typography>
                    {params?.row?.module_type === "Pharmacy" ?
                        <Typography id='eMed_Com_Patient_UhidText'>{(params?.row?.bill_type === "Return" ? params?.row?.bill_type : '')}
                        </Typography> : null}
                </Box>), valueGetter: (params) => {
                    const module = params?.row?.module_type || "";
                    const bill = params?.row?.bill_type === "Return" ? "Return" : "";
                    return bill ? `${module} - ${bill}` : module;
                },
            },
            {
                field: "pov", headerName: t("Purpose Of Visit"), flex: 0.143, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.pov ? params?.row?.pov?.length > 15 ?
                    <Tooltip placement='top' title={params?.row?.pov} arrow><div>{params?.row?.pov?.slice(0, 15) + '...'}</div></Tooltip> : params?.row?.pov : "-"}
                </Box>)
            },
            {
                field: "gross_amount", headerName: `${t("TotalValue")} (${CurrencySymbol})`, flex: 0.143, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.gross_amount ? AmountFormat(params?.row?.gross_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: "payable_amount", headerName: `${t("CorporatePayable")} (${CurrencySymbol})`, flex: 0.143, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.payable_amount ? AmountFormat(params?.row?.payable_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: "patient_payable", headerName: `${t("Patient Payable")} (${CurrencySymbol})`, flex: 0.143, type: "number",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_payable ? AmountFormat(params?.row?.patient_payable).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("TotalAmount"), this.state.corporateTotalAmount)}
                        {AmountsCard(t("Total Net Amount"), this.state.corporateTotalNetAmount)}
                        {AmountsCard(t("CorporatePayable"), this.state.corporatePatientPayable)}
                        {AmountsCard(t("Patient Payable"), this.state.patientPayable)}
                        {this.props.fromRadiology ? null : AmountsCard(t("Return Amount"), this.state.return_amount)}
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className={this.props.fromPharmacy ? 'eMed_Pharma_rts_btn': 'eMed_usrconf_btn'} onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className={this.props.fromPharmacy ? 'eMed_Pharma_rts_actionimg' : 'eMed_action_img'} />
                            </Button>
                        </Box>
                        {/* <Button className='eMed_usrconf_btn'>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button> */}
                        <Button emed_tid="rpt_corppatient_export" className={this.props.fromPharmacy ? 'eMed_Pharma_rts_btn': 'eMed_usrconf_btn'} disabled={this.state.disableBtn} onClick={() => this.getCorpBillExcel()}>
                            <Box component={'img'} src={ImagePaths.ExportIcon.default} alt='export' className={this.props.fromPharmacy ? 'eMed_Pharma_rts_actionimg' : 'eMed_action_img'} />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.corporatePatientData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                        loading={this.state.isLoader}
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(CopPatientReport)